import USER_TYPES from '@/constants/authorization/user-types'

export default {
  namespaced: true,
  state: {
    adminPermissions: {}, // super-admin permissions
    primaryAccount: false,
    userType: null,
    admin_level: 2,
  },
  getters: {
    isSuperAdmin: (state: any) => state.admin_level === 0 && state.primaryAccount,
    isManager: (state: any) => state.admin_level === 3 && state.primaryAccount,
    isPrimaryAccount: (state: any) => state.primaryAccount,
    isSubUser: (state: any) => !state.primaryAccount,
    isBranchAdmin: (state: any) => state.userType === USER_TYPES.BRANCH_ADMIN,
    isChef: (state: any) => state.userType === USER_TYPES.KITCHEN_RUNNER,
    isSupervisor: (state: any) => state.userType === USER_TYPES.KITCHEN_SUPERVISOR,
    isWaiter: (state: any) => state.userType === USER_TYPES.KITCHEN_WAITER,
    isAuditor: (state: any) => state.userType === USER_TYPES.AUDITOR,
    isDriver: (state: any) => state.userType === USER_TYPES.Driver,
    isKitchenUser: (state: any, getters: any) => getters.isChef || getters.isSupervisor || getters.isWaiter,
    isUserHasType: (state: any, getters: any) => (type: number, strict = false) => {
      switch (type) {
        case USER_TYPES.SUPER_ADMIN: return getters.isSuperAdmin
        case USER_TYPES.ACCOUNT_MANAGER: return getters.isManager || (!strict && getters.isSuperAdmin)
        case USER_TYPES.OWNER: return getters.isPrimaryAccount || (!strict && getters.isSuperAdmin)
        case USER_TYPES.BRANCH_ADMIN: return getters.isBranchAdmin || (!strict && getters.isPrimaryAccount)
        case USER_TYPES.KITCHEN_USER: return getters.isKitchenUser || (!strict && getters.isPrimaryAccount)
        case USER_TYPES.Driver: return getters.isDriver || (!strict && getters.isPrimaryAccount)
        default: return state.userType === type || (!strict && getters.isPrimaryAccount)
      }
    },
    isSuperAdminHasPermission: (state: any) => (permission: string) => state.adminPermissions?.[permission] ?? false,
  },
  mutations: {
    SET_PERMISSIONS(state: any, { admin_permissions, user }: any) {
      state.primaryAccount = user.primaryAccount
      state.adminPermissions = admin_permissions ?? []
      state.userType = user.type
      state.admin_level = user.admin_level
    },
  },
}
